module.exports = __webpack_public_path__ + "img/cul_4.dc952509.jpg";